module.exports = __webpack_public_path__ + "media/images/icons/chat-bubble-6f4d3449102a4c68766df0f9cfd10768.svg";